import {isObject} from "@spoferan/spoferan-ts-core";

export default {

    methods: {
        parseErrorMessage(error) {
            const fallbackMessage = this.$nuxt.isOffline ? this.$t('error.offline.message') :
                this.$t('error.unknown');

            if (!error) {
                return fallbackMessage;
            }

            // Handle plain error messages
            if (!isObject(error)) {
                return error;
            }

            // Handle request errors
            // Custom error message from our API
            if (error.message) {
                return error.message;
            }

            // Parse by status code
            const code = parseInt(error.statusCode);
            switch (code) {
                case 403:
                    return this.$t('error.403.message' );
                case 404:
                    return this.$t('error.404.message');
                case 422:
                    return this.$t('error.422.message');
                case 503:
                    return this.$t('error.503.message');
            }
        }

    }
}

